module.exports = __webpack_public_path__ + "assets/e3225c6a909ea545b532b8d17a8b2ecf.svg";